import { useEffect, useState } from 'react';

import Loader from './components/common/Loader';
import Sidebar from './components/common/Sidebar';
import useDarkSide from './hooks/useDarkSide';
import AppRoutes from './routes/AppRoutes';
import { motion } from 'framer-motion';
import './App.css';
import AnimatedCursor from "react-animated-cursor"


const App = () => {
  const [themeColor, setThemeColor] = useState(localStorage.themeColor);
  const [themeRounded, setThemeRounded] = useState(localStorage.themeRounded);
  const [visible, setVisible] = useState(window.innerWidth > 768 ? 'true' : 'false');
  const [playAnimation, setPlayAnimation] = useState(false);
  const [colorTheme, setTheme] = useDarkSide();



  // This will run one time after the component mounts
  useEffect(() => {
    const onPageLoad = () => {
      setPlayAnimation(true);
    };

    // Check if the page has already loaded
    setTimeout(() => {
      if (document.readyState === 'complete') {
        onPageLoad();
      } else {
        window.addEventListener('load', onPageLoad);
        // Remove the event listener when component unmounts
        return () => window.removeEventListener('load', onPageLoad);
      }
    }, 3000);
  }, []);
  /* 
    useEffect(() => {
  
      // Wait for 3 seconds
      setTimeout(() => {
        setPlayAnimation(true);
      }, 3000);
    }, []); */


  useEffect(() => {
    // Save theme to Local Storage
    localStorage.setItem('themeColor', themeColor);
    localStorage.setItem('themeRounded', themeRounded);
  }, [themeColor, themeRounded]);

  return (
    <>
      <div className={`
      ${themeColor === "yellow" ? "theme-yellow"
          : themeColor === "emerald" ? "theme-emerald"
            : themeColor === "orange" ? "theme-orange"
              : themeColor === "purple" ? "theme-purple"
                : themeColor === "rose" ? "theme-rose"
                  : themeColor === "cyan" ? "theme-cyan"
                    : ""}
                  ${themeRounded === "lg" ? "theme-rounded-lg"
          : themeRounded === "md" ? "theme-rounded-md"
            : themeRounded === "sm" ? "theme-rounded-sm"
              : ""} `

      }>
        <AnimatedCursor
          outerStyle={{
            border: '5px solid var(--cursor-color)'
          }}
          innerStyle={{
            backgroundColor: 'var(--cursor-color)'
          }}
        />
        {playAnimation ? (
          <motion.div
            className='h-screen'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <div className='mx-auto w-screen relative'>
              {window.innerWidth > 768 ? (
                <div className='flex gap-5 h-screen p-5 bg-slate-100 dark:bg-gray-800'>
                  <div className='w-full md:w-1/4 bg-white dark:bg-gray-900 rounded-custom z-10'>
                    <Sidebar setThemeColor={setThemeColor} setThemeRounded={setThemeRounded} colorTheme={colorTheme} setTheme={setTheme} />
                  </div>
                  <div className='w-full md:w-3/4 bg-slate-100 dark:bg-gray-800 z-20'>
                    <AppRoutes />
                  </div>
                </div>
              ) : (
                <>
                  <div className='flex gap-5 h-screen md:p-5 p-2 bg-slate-100 dark:bg-gray-800'>
                    {!visible && <div className='w-full md:w-1/4 bg-white dark:bg-gray-900 rounded-custom z-10'>
                      <Sidebar setThemeColor={setThemeColor} setThemeRounded={setThemeRounded} visible={visible} setVisible={setVisible} colorTheme={colorTheme} setTheme={setTheme} />
                    </div>}
                    {visible && <div className='w-full md:w-3/4 bg-slate-100 dark:bg-gray-800 z-20'>
                      <AppRoutes visible={visible} setVisible={setVisible} />
                    </div>}
                  </div>

                </>

              )}
            </div>
          </motion.div>
        ) : (
          <Loader />
        )
        }
      </div>

    </>
  );
}

export default App;
